import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { HTTPTourPrice } from 'src/app/models';
import {environment} from "../../../../../environments/environment";
import {PriceFormatPipe} from "../../../pipes/price-format/price-format.pipe";

@Component({
  selector: 'app-tour-prices-value',
  template: `
    <div class="ng-prices">
      <div *ngIf="!this.hideDiscount" class="ng-old-price">
        {{ priceWithoutDiscount | priceFormat:price.currency }}
      </div>
      <span class="ng-price">{{ price.value | priceFormat:price.currency }}</span>
    </div>
  `,
  styleUrls: environment.mobile ? ['./tour-prices-value.component.mobile.scss'] : ['./tour-prices-value.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, PriceFormatPipe]
})
export class TourPricesValueComponent {
  @Input() price: HTTPTourPrice;
  @Input() discount: number;
  @Input() hideDiscount!: boolean;

  get priceWithoutDiscount(): number {
    return this.price.value * (100 + this.discount) / 100;
  }

  get isShowDiscount() {
    return this.discount > 0;
  }
}
